import { NgModule } from '@angular/core';

import { UploadsRoutingModule } from './uploads-routing.module';
import { TemplateViewComponent } from './template-view/template-view.component';
import { TemplateCreateComponent } from './template-create/template-create.component';
import { HomeModule } from '../home/home.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NotificationModule } from '../notification.module';
import { MaterialModule } from '../material/material.module';
import { NotificationService } from '../service/notification.service';
import { TemplateEditComponent } from './template-edit/template-edit.component';
import { UploadsCreateComponent } from './uploads-create/uploads-create.component';
import { UploadsEditComponent } from './uploads-edit/uploads-edit.component';
import { UploadsViewComponent } from './uploads-view/uploads-view.component';
import { UploadDataComponent } from './upload-data/upload-data.component';
import { UpdateManualDataComponent } from './update-manual-data/update-manual-data.component';
import { UpdateAdjustmentResultsComponent } from './update-adjustment-results/update-adjustment-results.component';
import { UpdateGoalResultsComponent } from './update-goal-results/update-goal-results.component';
import { UpdateAdjustmentsEditComponent } from './update-adjustments-edit/update-adjustments-edit.component';
import { UpdateGoalsEditComponent } from './update-goals-edit/update-goals-edit.component';
import { DagDataAnalyticsComponent } from './dag-data-analytics/dag-data-analytics.component';


@NgModule({
  declarations: [
    TemplateViewComponent,
    TemplateCreateComponent,
    TemplateEditComponent,
    UploadsCreateComponent,
    UploadsEditComponent,
    UploadsViewComponent,
    UploadDataComponent,
    UpdateManualDataComponent,
    UpdateAdjustmentResultsComponent,
    UpdateGoalResultsComponent,
    UpdateAdjustmentsEditComponent,
    UpdateGoalsEditComponent,
    DagDataAnalyticsComponent
  ],
  imports: [
    UploadsRoutingModule,
    HomeModule,
    FormsModule,
    ReactiveFormsModule,
    NotificationModule,
    MaterialModule,
    HttpClientModule
  ],
  providers: [NotificationService]
})
export class UploadsModule { }
